/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {useMutation, useQueryClient} from 'react-query';
import {error} from '@ion/core/src/logger/logger';
import {deleteEmissionTester} from '@ion/core/src/services/Connect';
import {QueryKey} from '../config/QueryKeys';
import {createMutationResult} from '../utils/helpers';
import {UseDefaultQueryResult} from './types';

export type UseDeleteTesterResult = UseDefaultQueryResult & {
  deleteTester: (accountId) => void;
}

const api = async(accountId) => {
  try {
    return await deleteEmissionTester({accountId});
  } catch (err) {
    error(err);
    throw new Error(`An ${err.status || ''} Error Occurred`);
  }
};

/**
 * Common hook for delete a CARB emission Tester entity.
 *
 * ```typescript
 *
 *    import useDeleteTester from '@ion/query/src/hooks/';
 *
 *    const {deleteTester, isSuccess, isError} = useDeleteTester();
 *
 * ```
 */
export const useDeleteTester = (): UseDeleteTesterResult => {
  const queryClient = useQueryClient();
  const mutation    = useMutation(api, {
    onSettled : () => {
      queryClient.invalidateQueries([QueryKey.DELETE_TESTER]);
    }
  });

  return createMutationResult(
    mutation, {
      deleteTester : mutation.mutate
    }
  ) as UseDeleteTesterResult;
};

export default useDeleteTester;
